import * as React from 'react';

const LIMIT = 10;

export function useSeeMore<T>(options: { limit?: number; data?: T[] }) {
  const limit = options.limit ?? LIMIT;
  const data = options.data ?? [];

  const [flag, setFlag] = React.useState(false);

  return {
    additional: data.length - limit,
    canSeeMore: data.length > limit,
    data: flag ? data : data.slice(0, limit),
    flag,
    toggle: () => setFlag((prev) => !prev),
  };
}
